/**
 * Build identity injected by the Vite `define` block (vite.config.ts) from the Cloudflare
 * Pages build env (CF_PAGES_COMMIT_SHA / CF_PAGES_BRANCH). The `typeof` guards keep this
 * module importable without Vite — `node --test` loads TS sources directly, where the
 * globals do not exist — falling back to 'local', which is also what local dev builds get.
 *
 * Consumers must import these constants rather than the raw `__BUILD_*__` globals.
 */

export const BUILD_SHA: string =
  typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'local';

export const BUILD_BRANCH: string =
  typeof __BUILD_BRANCH__ !== 'undefined' ? __BUILD_BRANCH__ : 'local';
